import { render, staticRenderFns } from "./RegulatorManagerForm.vue?vue&type=template&id=e3cc2094&"
import script from "./RegulatorManagerForm.vue?vue&type=script&lang=ts&"
export * from "./RegulatorManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports